var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"website-pro-module",class:_vm.customClasses,style:(_vm.style)},_vm._l((_vm.module.modules),function(child){return _c(child.name,{key:child.id,tag:"component",attrs:{"module":child}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }